var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 26 26",
    fill: "#047d95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13 2 A 11 11 0 0 1 23.46 9.6 A 11 11 0 0 1 13 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 23.46 9.6 A 11 11 0 0 1 19.47 21.9 A 11 11 0 0 1 23.46 9.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.47 21.9 A 11 11 0 0 1 6.53 21.9 A 11 11 0 0 1 19.47 21.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.53 21.9 A 11 11 0 0 1 2.54 9.6 A 11 11 0 0 1 6.53 21.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.54 9.6 A 11 11 0 0 1 13 2 A 11 11 0 0 1 2.54 9.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.14c5a1160eefa7840ba792c52774132d.svg";
export { ForwardRef as ReactComponent };